import { ResourceChoice } from "./interface";
import {
  addSchemaWaterSupply,
  editSchemaWaterSupply,
  closeSchemaWaterSupply,
} from "./data/coldWaterSupplyForm/validator";
import {
  addSchemaGasCommunication,
  editSchemaGasCommunication,
  closeSchemaGasCommunication,
} from "./data/gasCommunicationForm/validator";
import {
  addSchemaHeatSupply,
  editSchemaHeatSupply,
  closeSchemaHeatSupply,
} from "./data/heatSupplyForm/validator";
import {
  addSchemaLighting,
  editSchemaLighting,
  closeSchemaLighting,
} from "./data/lightingForm/validator";
import {
  addSchemaDrainage,
  editSchemaDrainage,
  closeSchemaDrainage,
} from "./data/drainageForm/validator";
import {
  addSchemaPowerSupply,
  editSchemaPowerSupply,
  closeSchemaPowerSupply,
} from "./data/powerSupplyForm/validator";
import {
  initialValuesGasCommunication,
  initialValuesHeatSupply,
  initialValuesColdWaterSupply,
  initialValuesLighting,
  initialValuesDrainage,
  initialValuesPowerSupply,
} from "./hooks";
import {
  HEAT_SUPPLY_KEY,
  COLD_WATER_SUPPLY_KEY,
  GAS_COMMUNICATION_KEY,
  LIGHING_KEY,
  DRAINAGE_KEY,
  POWER_SUPPLY_KEY,
} from "./constants";

export const CHOICES_LIST: Array<ResourceChoice> = [
  {
    id: HEAT_SUPPLY_KEY,
    gridTypeId: 1,
    title: "Теплоснабжение",
    isZKH: true,
    addSchema: addSchemaHeatSupply,
    editSchema: editSchemaHeatSupply,
    closeSchema: closeSchemaHeatSupply,
    initialValues: initialValuesHeatSupply,
  },
  {
    id: COLD_WATER_SUPPLY_KEY,
    gridTypeId: 2,
    title: "Холодное водоснабжение",
    isZKH: true,
    addSchema: addSchemaWaterSupply,
    editSchema: editSchemaWaterSupply,
    closeSchema: closeSchemaWaterSupply,
    initialValues: initialValuesColdWaterSupply,
  },
  {
    id: GAS_COMMUNICATION_KEY,
    gridTypeId: 5,
    title: "Газоснабжение",
    isZKH: true,
    addSchema: addSchemaGasCommunication,
    editSchema: editSchemaGasCommunication,
    closeSchema: closeSchemaGasCommunication,
    initialValues: initialValuesGasCommunication,
  },
  {
    id: LIGHING_KEY,
    gridTypeId: 6,
    title: "Освещение",
    isZKH: false,
    addSchema: addSchemaLighting,
    editSchema: editSchemaLighting,
    closeSchema: closeSchemaLighting,
    initialValues: initialValuesLighting,
  },
  {
    id: DRAINAGE_KEY,
    gridTypeId: 3,
    title: "Водоотведение",
    isZKH: true,
    addSchema: addSchemaDrainage,
    editSchema: editSchemaDrainage,
    closeSchema: closeSchemaDrainage,
    initialValues: initialValuesDrainage,
  },
  {
    id: POWER_SUPPLY_KEY,
    gridTypeId: 4,
    title: "Электроснабжение",
    isZKH: false,
    addSchema: addSchemaPowerSupply,
    editSchema: editSchemaPowerSupply,
    closeSchema: closeSchemaPowerSupply,
    initialValues: initialValuesPowerSupply,
  },
];
